require('./axios')
require('./vuetify')
// require('./aos')
// require('./vuevideo')
// require('./vuepdf')
// require('./fb-sdk')
// require('./g-auth')